// eslint-disable-next-line import/prefer-default-export
export { logMessage } from './logMessage';
